import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 园区后台 系统管理 园区管理接口
 */

export const A_Park = {
    // 获取园区权限列表
    getPowerList(parmas, expend) {
        return send("GET", "/api/system/user/permission/all", parmas, expend);
    },
    // 获取园区权限
    getPower(parmas, expend) {
        return send("GET", "/api/system/park/permission/get", parmas, expend);
    },
    // 修改园区权限
    postPowerEdit(parmas, expend) {
        return send("POST", "/api/system/park/permission/edit", parmas, expend);
    },
    // 查询接口
    getParkList(parmas, expend) {
        return send("GET", "/api/system/park/find", parmas, expend);
    },
    // 添加接口
    createPark(parmas, expend) {
        return send("POST", "/api/system/park/create", parmas, expend);
    },
    // 修改接口
    modifyPark(parmas, expend) {
        return send("POST", "/api/system/park/modify", parmas, expend);
    },
    // 删除接口
    delPark(parmas, expend) {
        return send("POST", "/api/system/park/delete", parmas, expend);
    },
    // 退出登录
    loginOut(parmas, expend) {
        return send("POST", "/api/user/loginOut", parmas, expend);
    }
}